import KioskComponentsContainer from './KioskComponentsContainer.jsx';

export default KioskComponentsContainer;


// WEBPACK FOOTER //
// ./src/components/KioskComponentsContainer/index.jsx